<mat-card style="margin-top:30px;margin-left:10px;margin-right:0px;width:99%;" class="card-grid-border">
    <mat-card-header>
       
      </mat-card-header>    
    <mat-card-content>
       
        <div style="margin-top:20px;"></div>


<ng-container *ngIf="this.updateEmailMode === false">
    <span style="margin-left: 0px;margin-top:20px;"  class="lanai-page-title">Add Additional Email Address</span>
    <form 
    (ngSubmit)="onSubmitAddNewEmailAddress()" 
    novalidate
    [formGroup]="emailNewForm" 
    
    style="margin-top:20px;">
    <div class="row margin-top:20px;">
        <div class="col-4">
            <mat-form-field appearance="fill" style="width:100%">
                <mat-label>Email Address</mat-label>
                <input matInput placeholder="Email Address" formControlName="additionalEmailAddress" autocomplete="chrome-off"   (keydown)="onKeyDown($event)">
                <mat-error>The Email address is required</mat-error>
            </mat-form-field>
        </div>

        <div class="col-2">
            <mat-form-field appearance="fill" style="width:100%">
                <mat-label>Name</mat-label>
                <input matInput placeholder="Name"  formControlName="additionalEmailName" autocomplete="chrome-off"   (keydown)="onKeyDown($event)">
              </mat-form-field>
        </div>
        <div class="col-2">
            <mat-form-field appearance="fill" style="width:100%">
                <mat-label>Title</mat-label>
                <input matInput placeholder="Title" formControlName="additionalEmailTitle" autocomplete="chrome-off"   (keydown)="onKeyDown($event)">
              </mat-form-field>
        </div>
        <div class="col-4">
            <mat-form-field appearance="fill" style="width:100%;color:gray">
                <mat-label>Comments</mat-label>
                <input matInput placeholder="Comments" formControlName="additionalEmailComments" autocomplete="chrome-off"   (keydown)="onKeyDown($event)">
              </mat-form-field>
        </div>
       
    </div>
  
    <button type="submit" class="btn btn-primary mt-3 ace-blue" style="margin-left:20px;" [disabled]="!emailNewForm.valid">Submit</button>
    <button type="button" class="btn btn-light mt-3" style="margin-left:5px;" (click)="onResetAdditionalEmailNewForm()">Clear</button>
    </form>
</ng-container>

<ng-container *ngIf="this.updateEmailMode">
    <h1>Update Additional Email</h1>
    <form 
    (ngSubmit)="onSubmitUpdateEmailAddress()" 
    novalidate
    [formGroup]="emailEditForm" 
    
    style="margin-top:20px;">
    <div class="row margin-top:20px;">
        <div class="col-4">
            <mat-form-field appearance="fill" style="width:100%">
                <mat-label>Email Address</mat-label>
                <input matInput placeholder="Email Address" formControlName="additionalEditEmailAddress" autocomplete="chrome-off" (keydown)="onKeyDown($event)">
                <mat-error>The Email address is required</mat-error>
            </mat-form-field>
        </div>

        <div class="col-2">
            <mat-form-field appearance="fill" style="width:100%">
                <mat-label>Name</mat-label>
                <input matInput placeholder="Name"  formControlName="additionalEditEmailName" autocomplete="chrome-off" (keydown)="onKeyDown($event)">
              </mat-form-field>
        </div>
        <div class="col-2">
            <mat-form-field appearance="fill" style="width:100%">
                <mat-label>Title</mat-label>
                <input matInput placeholder="Title" formControlName="additionalEditEmailTitle" autocomplete="chrome-off" (keydown)="onKeyDown($event)">
              </mat-form-field>
        </div>
        <div class="col-4">
            <mat-form-field appearance="fill" style="width:100%;color:gray">
                <mat-label>Comments</mat-label>
                <input matInput placeholder="Comments" formControlName="additionalEditEmailComments" autocomplete="chrome-off" (keydown)="onKeyDown($event)">
              </mat-form-field>
        </div>
       
    </div>
  
    <button type="submit" class="btn btn-primary mt-3 ace-blue" style="margin-left:20px;" [disabled]="!emailEditForm.valid">Update Email Address</button>
    <button type="button" class="btn btn-light mt-3" style="margin-left:5px;" (click)="onEnableCancelEmailEditMode()">Cancel</button>
    </form>
</ng-container>

<hr>

<ng-container *ngIf="this.additionalEmails.length > 0">


    <igx-grid  [batchEditing]="true" #gridProfile [data]="this.additionalEmails" [width]="'99%'" [height]="'400px;'" [autoGenerate]="false" style=margin-left:10px;margin-top:20px;
    paste-handler  [primaryKey]="'additionalEmailId'" [rowEditable]="false"
    [allowFiltering]="true"  filterMode="excelStyleFilter" displayDensity="compact" 
    [emptyGridMessage]="'No Additional Contacts for Companyy'" >


    <igx-column field="" header=" " [sortable]="true" width="150px" required style="font-size:10px;"  [resizable]="true">
        <ng-template #compositeTemp igxCell let-cell="cell">
            <button mat-icon-button aria-label="Edit Contact" (click)="onEnableEmailEditMode(cell.row.data.additionalEmailId)" matTooltip="Edit Contact">
                <mat-icon>edit</mat-icon>
            </button>
            <button mat-icon-button aria-label="Delete Contact" (click)="onDeleteEmail(cell.row.data.additionalEmailId)" matTooltip="Delete Contact" style="margin-left:20px;">
                <mat-icon>delete</mat-icon>
            </button>
        </ng-template>
    </igx-column>

    <igx-column field="name" header="Name" [sortable]="true" width="150px" required style="font-size:10px;"  [resizable]="true"></igx-column>

    <igx-column field="title" header="Title" [sortable]="true" width="250px" required style="font-size:10px;"  [resizable]="true"></igx-column>

    <igx-column field="emailAddress" header="Email Address" [sortable]="true" width="450px" required style="font-size:10px;"  [resizable]="true">
        <ng-template #compositeTemp igxCell let-cell="cell">
        
            @if(cell.row.data.emailAddress != '' && cell.row.data.emailAddress != null){
                {{cell.row.data.emailAddress}} 
                <button mat-icon-button aria-label="Copy Company Id" (click)="onCopyMessage('Email Address Name copied to clipboard')"  [cdkCopyToClipboard]="cell.row.data.emailAddress"  style="height:10px;width:10px;position:relative;top: -10px;margin-left:5px;"   matTooltip="Copy Contact Email Address">
                    <mat-icon>content_copy</mat-icon>
                </button>
            }
            
        </ng-template>
    
    </igx-column>

    <igx-column field="comments" header="Comments" [sortable]="true" width="350px" required style="font-size:10px;"  [resizable]="true"></igx-column>

    </igx-grid>
    </ng-container>

</mat-card-content>
<mat-card-actions style="margin-top:20px;">
    <hr />

  </mat-card-actions>
</mat-card>



